
import axios from "axios"
import ApiStore from "./ApiStore";
// var querystring = require('querystring');


export class GenDocStore extends ApiStore{
  constructor() {

    super();
  }

  newDoc(typeDoc,nameDoc,completeFunc){
    axios.get('/'+typeDoc+'/doc/?format=json&new_'+nameDoc+'=true')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  newDocInvoiceStatus(typeDoc,nameDoc,docNo,invoiceStatusDocType,completeFunc){
    axios.get('/'+typeDoc+'/doc/?format=json&new_'+nameDoc+'=true&iv='+docNo+'&invoice_doc_type='+invoiceStatusDocType)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  newDocInvoiceListStatus(typeDoc,nameDoc,docNo,invoiceStatusDocType,completeFunc){
    axios.get('/'+typeDoc+'/doc/?format=json&new_'+nameDoc+'=true&ivlist='+docNo+'&invoice_doc_type='+invoiceStatusDocType)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  newDocPO(typeDoc,nameDoc,docNo,docType,completeFunc){
    axios.get('/'+typeDoc+'/doc/?format=json&new_'+nameDoc+'=true&po='+docNo+'&doc_type='+docType)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  newDocFromWork(typeDoc,nameDoc,workNo,completeFunc){
    axios.get('/'+typeDoc+'/doc/?format=json&new_'+nameDoc+'=true&wo='+workNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadDoc(docNo,typeDoc,nameDoc,completeFunc){
    axios.get('/'+typeDoc+'/doc/?format=json&'+nameDoc+'='+docNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadWorkRecord(typeDoc,workNo,completeFunc){
    axios.get('/'+typeDoc+'/work_record/?format=json&wo='+workNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveDoc(postData,typeDoc,completeFunc,errorFunc){
    
    console.log('postData',postData)    
    axios.post('/'+typeDoc+'/doc/',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }

  delGenDoc(typeDoc,dsNo,completeFunc,errorFunc){
    dsNo = dsNo.replace("/", "_");
    axios.delete('/'+typeDoc+'/doc/'+dsNo)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  newReceptionDoc(completeFunc){
    axios.get('/reception/doc?new_rc=true&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadReceptionDoc(rc,completeFunc) {
    axios.get('/reception/doc?rc='+rc+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveReceptionDoc(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)    
    axios.post('/reception/doc',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }

  updateStatusReceptionDoc(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)    
    axios.post('/reception/status',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }

  loadNewWithholdingTaxDoc(completeFunc) {
    axios.get('/withholdingtax/doc?new_wh=true&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadWithholdingTaxDoc(wh,completeFunc) {
    axios.get('/withholdingtax/doc?wh='+wh+'&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveWithholdingTaxDoc(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)    
    axios.post('/withholdingtax/doc',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }
}

export default new GenDocStore()



// WEBPACK FOOTER //
// ./src/stores/GenDocStore.js